var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h6 mt-2 mb-3 d-block d-md-none"},[_c('v-icon',{staticStyle:{"margin-bottom":"3px"},attrs:{"color":"grey"}},[_vm._v("mdi-tune")]),_vm._v(" "+_vm._s(_vm.$t('title'))+" ")],1),_c('a-subscription-widget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }